
import OverscrollController from '../../modules/OverscrollController';

export default class EventMenu {
  get classes() {
    return {
      isMenuOpened: "is-menu-opened",
    };
  }

  constructor() {
    this.menuButtonElement = document.querySelector("[data-menu-trigger]");
    this.menuElement = document.querySelector("[data-menu]");
    if (!this.menuButtonElement || !this.menuElement) return;
    this.menuInnerElement = this.menuElement.querySelector("[data-menu-inner]");
    this.menuCloseButtonElement = this.menuElement.querySelector("[data-menu-btn]");
    this.menuContentElement = this.menuElement.querySelector("[data-menu-content]");
    this.menuCloseElements = [...this.menuElement.querySelectorAll("[data-menu-close]")];

    this.init();
  }

  init() {
    new OverscrollController(this.menuElement, this.menuInnerElement);
    this.setupStyle();
    this.bindEvents();
  }

  setupStyle() {
    gsap.set(this.menuContentElement, { xPercent: 100 })
    gsap.set([this.menuElement, this.menuCloseButtonElement], { autoAlpha: 0 })
  }

  bindEvents() {
    this.menuButtonElement.addEventListener("click", this.toggleMenu.bind(this));
    this.menuCloseElements.forEach((menuCloseElement) => {
      menuCloseElement.addEventListener("click", this.hideMenu.bind(this));
    });
  }

  toggleMenu() {
    document.documentElement.classList.contains(this.classes.isMenuOpened) ? this.hideMenu() : this.showMenu();
  }

  showMenu() {
    this.menuElement.scrollTop = 0;

    document.documentElement.classList.add(this.classes.isMenuOpened);

    const tl = gsap.timeline({ defaults: { duration: 0.25, ease: 'none' }});
    tl
      .to(this.menuElement, { autoAlpha: 1})
      .to(this.menuContentElement, { xPercent: 0, duration: 0.5, ease: 'power2.out' }, '<')
      .to(this.menuCloseButtonElement, {
        autoAlpha: 1,
        onComplete: () => {
          ScrollTrigger.normalizeScroll(false);
        }
      }, '+=0')
  }

  hideMenu() {
    if (!document.documentElement.classList.contains(this.classes.isMenuOpened)) return;

    document.documentElement.classList.remove(this.classes.isMenuOpened);

    const tl = gsap.timeline({ defaults: { duration: 0.25, ease: 'none' }});
    tl
      .to(this.menuContentElement, { xPercent: 100, duration: 0.5, ease: 'power2.out' })
      .to(this.menuCloseButtonElement, { autoAlpha: 0 }, '<')
      .to(this.menuElement, {
        autoAlpha: 0,
        onComplete: () => {
          document.documentElement.classList.remove(this.classes.isMenuOpened);
          ScrollTrigger.normalizeScroll(true);
        }
      })
  }
}
